import React, { useState } from 'react';

import styles from './EventDetail.scss';

function EventDetail(props) {
    const [isOpen, setIsOpen] = useState(true);

    function EventDetailTitle() {
        if (props.detail.title) {
            return <p>{props.detail.title} ({props.detail.view})</p>;
        } else {
            return <p>{props.detail.view}</p>;
        }
    }

    function ActionButtons() {
        if (isOpen) {
            return (
                <div className={styles.actionButtons} data-cy="EventDetail">
                    <i className={styles.icon} onClick={props.onRemoveItem} data-cy="EventDetail-onRemoveItem">{'delete_forever'}</i>
                    <i className={styles.icon} onClick={() => setIsOpen(false)} data-cy="EventDetail-setIsOpen">{'expand_less'}</i>
                </div>
            );
        } else {
            return (
                <i className={styles.icon} onClick={() => setIsOpen(true)} data-cy="EventDetail-onClick">{'expand_more'}</i>
            );
        }
    }

    const View = props.view;
    return (
        <div className={styles.parent} data-cy="EventDetail-return">
            <div className={styles.header} data-cy="EventDetail-header">
                <EventDetailTitle props={props} />
                <ActionButtons />
            </div>

            { isOpen && (
                <View
                    key={`event-detail-${props.detail.id}-date`}
                    dataSources={props.dataSources}
                    values={props.detail}
                    onItemChanged={props.onItemChanged}
                    data-cy="EventDetail-View"
                />
            )}
        </div>
    );
}

export default EventDetail;
